import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { app, reset1, reset2 } from "./routes";
import { ChangePassword, SendResetPassword } from 'pages'

const ResetRoutes = () => {

    return (
        <Routes>
            <Route index element={<Navigate to={reset1} replace />} />
            <Route path={reset1} element={
                <SendResetPassword />
            } />
            <Route path={`${reset2}/:uid/:token`} element={
                <ChangePassword />
            } />
        </Routes>
    );
}

export default ResetRoutes
